exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.subitem-wrapper[data-v-8fb13b4e] {\n&::before,\n    &::after {\n        margin: auto;\n        content: '';\n}\n}\n", ""]);

// exports
